// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.tracking.RentalManagerUserTrackingV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserTrackingV2WebApiHandler_event,
  RentalManagerUserTrackingV2WebApiHandler_listing,
  RentalManagerUserTrackingV2WebApiHandler_log,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserTrackingEventV2RequestDto,
  UserTrackingListingV2RequestDto,
  UserTrackingLogV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserTrackingV2WebApiHandler_event_Args {
  postData: UserTrackingEventV2RequestDto;
}

export type RentalManagerUserTrackingV2WebApiHandler_event_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserTrackingV2WebApiHandler_event_Args
>;

/**
 * Track event
 */
export const useRentalManagerUserTrackingV2WebApiHandler_event = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserTrackingV2WebApiHandler_event_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserTrackingV2WebApiHandler_event_Args) =>
      RentalManagerUserTrackingV2WebApiHandler_event(args.postData, httpClient),
  });
};

export interface RentalManagerUserTrackingV2WebApiHandler_listing_Args {
  postData: UserTrackingListingV2RequestDto;
}

export type RentalManagerUserTrackingV2WebApiHandler_listing_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserTrackingV2WebApiHandler_listing_Args
>;

/**
 * Track listing event
 */
export const useRentalManagerUserTrackingV2WebApiHandler_listing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserTrackingV2WebApiHandler_listing_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserTrackingV2WebApiHandler_listing_Args) =>
      RentalManagerUserTrackingV2WebApiHandler_listing(args.postData, httpClient),
  });
};

export interface RentalManagerUserTrackingV2WebApiHandler_log_Args {
  postData: UserTrackingLogV2RequestDto;
}

export type RentalManagerUserTrackingV2WebApiHandler_log_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserTrackingV2WebApiHandler_log_Args
>;

/**
 * Log events for debugging purposes
 */
export const useRentalManagerUserTrackingV2WebApiHandler_log = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserTrackingV2WebApiHandler_log_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserTrackingV2WebApiHandler_log_Args) =>
      RentalManagerUserTrackingV2WebApiHandler_log(args.postData, httpClient),
  });
};
